<template>
	<div class="el-dialog-body-spacing">
		<el-dialog title="虚拟数据设置" :model-value="dialogVisible" width="600px" :before-close="hideDialog"
			:close-on-click-modal='false' append-to-body>
			<div style="position: relative">
				<el-form :model="pushData" :rules="rules" ref="formBox" label-width="120px">
					<el-form-item label="点赞量" prop="virtualLikeVolume">
						<el-input v-model="pushData.virtualLikeVolume" placeholder="请输入0~9999的数字" style="width: 85%"></el-input>
					</el-form-item>
					<el-form-item label="分享量" prop="virtualShareVolume">
						<el-input v-model="pushData.virtualShareVolume" placeholder="请输入0~9999的数字" style="width: 85%"></el-input>
					</el-form-item>
					<el-form-item label="阅读量" prop="virtualReadVolume">
						<el-input v-model="pushData.virtualReadVolume" placeholder="请输入0~9999的数字" style="width: 85%"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="hideDialog">取 消</el-button>	
					<el-button color='#112DF2' type="primary" @click="confirm">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script>
	import Validate from '@/utils/rules'
	import {articleUpdateVirtualVolumeById} from '@/api'
	export default {
		props: {
			visiFlag: {
				type: Function,
				default: function() {}
			},
			articleItem:{
				type:Object,
				default:{}
			},
			type:{
				type:String,
				default: 'add'
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
		},
		data() {	
			return {
				pushData:{
					virtualShareVolume:'',
					id:'',
					virtualReadVolume:'',
					virtualLikeVolume:''
				},
				rules: {
					virtualLikeVolume: [{required: true,message: "请输入0~9999的数字",validator: Validate.virtualVolume,trigger: "blur"}],
					virtualReadVolume: [{required: true,message: "请输入0~9999的数字",validator: Validate.virtualVolume,trigger: "blur"}],
					virtualShareVolume: [{required: true,message: "请输入0~9999的数字",validator: Validate.virtualVolume,trigger: "blur"}]
				},
				isRefresh:false
			}
		},
		watch: {
			dialogVisible(v) {
				this.pushData = {
					id:'',
					virtualShareVolume:'',
					virtualReadVolume:'',
					virtualLikeVolume:''
				}
				if (v) {
					if (Object.keys(this.articleItem).length) {
						for (let key in this.pushData) {
							this.pushData[key] = this.articleItem[key]
						}
					}
				}
			}
		},
		methods: {
			confirm(){
				this.$refs.formBox.validate((valid)=>{
					if (valid) {
						let data = JSON.parse(JSON.stringify(this.pushData))
						articleUpdateVirtualVolumeById({data}).then(res=>{	
							if(res.success){
								this.$message.success(res.msg)
								this.isRefresh = true
								this.hideDialog()
							}else{
								this.loading = false
								this.$message.error(res.msg)
							}
						})
					}
				})
			},
			hideDialog() {
				this.visiFlag(false, this.isRefresh)
			}
		}
	}
</script>
<style rel="stylesheet/scss" lang='scss' scoped>
	.el-dialog__body{
		overflow: hidden;
		overflow-y:auto;
	}	
</style>
